import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Suspense, lazy } from "react";
import MouseGlow from "./components/MouseGlow";
import Index from "./pages/Index";

// Route-level code splitting – Home bleibt eager für LCP
const NotFound = lazy(() => import("./pages/NotFound"));
const BusinessCoaching = lazy(() => import("./pages/BusinessCoaching"));
const PositionierungMarke = lazy(() => import("./pages/BusinessCoaching.PositionierungMarke"));
const Angebotsentwicklung = lazy(() => import("./pages/BusinessCoaching.Angebotsentwicklung"));
const Preisstrategie = lazy(() => import("./pages/BusinessCoaching.Preisstrategie"));
const Geschaeftsmodell = lazy(() => import("./pages/BusinessCoaching.Geschaeftsmodell"));
const ZielsetzungErfolg = lazy(() => import("./pages/BusinessCoaching.ZielsetzungErfolg"));
const Foerdermittelberatung = lazy(() => import("./pages/Foerdermittelberatung"));
const FinanzplanungControlling = lazy(() => import("./pages/FinanzplanungControlling"));
const InqaCoaching = lazy(() => import("./pages/InqaCoaching"));
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const AvgsCoaching = lazy(() => import("./pages/AvgsCoaching"));
const BafaUnternehmensberatung = lazy(() => import("./pages/BafaUnternehmensberatung"));
const KompassFoerderung = lazy(() => import("./pages/KompassFoerderung"));
const Ratgeber = lazy(() => import("./pages/Ratgeber"));
const AvgsBeantragen = lazy(() => import("./pages/ratgeber/AvgsBeantragen"));
const BusinessplanRosenheim = lazy(() => import("./pages/ratgeber/BusinessplanRosenheim"));

const queryClient = new QueryClient();

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center" aria-live="polite" aria-busy="true">
    <div className="h-8 w-8 rounded-full border-2 border-accent border-t-transparent animate-spin" />
    <span className="sr-only">Seite wird geladen…</span>
  </div>
);

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <MouseGlow />
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/business-coaching" element={<BusinessCoaching />} />
              <Route path="/business-coaching/positionierung-marke" element={<PositionierungMarke />} />
              <Route path="/business-coaching/angebotsentwicklung-produktstrategie" element={<Angebotsentwicklung />} />
              <Route path="/business-coaching/preisstrategie-marktpositionierung" element={<Preisstrategie />} />
              <Route path="/business-coaching/geschaeftsmodell-entwicklung" element={<Geschaeftsmodell />} />
              <Route path="/business-coaching/zielsetzung-erfolgsmessung" element={<ZielsetzungErfolg />} />
              <Route path="/foerdermittelberatung" element={<Foerdermittelberatung />} />
              <Route path="/finanzplanung-controlling" element={<FinanzplanungControlling />} />
              <Route path="/inqa-coaching" element={<InqaCoaching />} />
              <Route path="/avgs-coaching" element={<AvgsCoaching />} />
              <Route path="/bafa-unternehmensberatung" element={<BafaUnternehmensberatung />} />
              <Route path="/kompass-foerderung" element={<KompassFoerderung />} />
              <Route path="/ratgeber" element={<Ratgeber />} />
              <Route path="/ratgeber/avgs-beantragen-rosenheim" element={<AvgsBeantragen />} />
              <Route path="/ratgeber/businessplan-rosenheim" element={<BusinessplanRosenheim />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
